var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { observable, action, runInAction } from "mobx";
import $http, { Q } from '@http';
var DetailStore = /** @class */ (function () {
    function DetailStore() {
        this.additionalDetail = "";
        this.attachmentList = [];
    }
    DetailStore.prototype.setAdditionalDetail = function (additionalDetail) {
        this.additionalDetail = additionalDetail;
    };
    DetailStore.prototype.clear = function () {
        this.additionalDetail = "";
        this.attachmentList = [];
    };
    DetailStore.prototype.clearAllTempData = function () {
    };
    DetailStore.prototype.uploadAttachment = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append('file', file);
                        return [4 /*yield*/, this.api().uploadFiles(formData).then(function (data) {
                                runInAction(function () {
                                    var _a;
                                    if (data && typeof data !== 'string') {
                                        var attach = {
                                            fileName: data.fileName,
                                            filePath: data.url,
                                            fileUrl: data.fileUrl,
                                            contentType: ((_a = file === null || file === void 0 ? void 0 : file.name) === null || _a === void 0 ? void 0 : _a.includes('.hevc')) ? 'video/x-matroska' : file.type,
                                            thumbnailUrl: data.downUrl,
                                        };
                                        _this.attachmentList.push(attach);
                                    }
                                });
                                return data && typeof data !== 'string' ? true : false;
                            }).catch(function () {
                                return false;
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    DetailStore.prototype.deleteAttachment = function (index) {
        var _this = this;
        runInAction(function () {
            _this.attachmentList.splice(index, 1);
            _this.attachmentList = __spreadArrays(_this.attachmentList);
        });
    };
    DetailStore.prototype.getDetailNextButtonDisable = function () {
        return this.additionalDetail.trim().length === 0;
    };
    DetailStore.prototype.setDetailData = function (wo) {
        this.attachmentList = wo.attachments;
        this.additionalDetail = wo.additionalDetail;
    };
    DetailStore.prototype.api = function () {
        return {
            uploadFiles: function (param) {
                return Q($http.post("/RSP/File/UploadRSP", param));
            },
        };
    };
    __decorate([
        observable
    ], DetailStore.prototype, "additionalDetail", void 0);
    __decorate([
        observable
    ], DetailStore.prototype, "attachmentList", void 0);
    __decorate([
        action.bound
    ], DetailStore.prototype, "setAdditionalDetail", null);
    __decorate([
        action.bound
    ], DetailStore.prototype, "clear", null);
    __decorate([
        action.bound
    ], DetailStore.prototype, "uploadAttachment", null);
    __decorate([
        action.bound
    ], DetailStore.prototype, "deleteAttachment", null);
    __decorate([
        action.bound
    ], DetailStore.prototype, "getDetailNextButtonDisable", null);
    __decorate([
        action.bound
    ], DetailStore.prototype, "setDetailData", null);
    return DetailStore;
}());
export default DetailStore;
